var map = {
	"./": 155,
	"./animations/five": 831,
	"./animations/five.json": 831,
	"./animations/four": 323,
	"./animations/four.json": 323,
	"./animations/one": 210,
	"./animations/one.json": 210,
	"./animations/three": 253,
	"./animations/three.json": 253,
	"./animations/two": 956,
	"./animations/two.json": 956,
	"./bg-dotted.svg": 111,
	"./github-icon.svg": 838,
	"./hanburger.svg": 255,
	"./index": 155,
	"./index.js": 155,
	"./languages": 440,
	"./languages/": 440,
	"./languages/c.svg": 904,
	"./languages/css.svg": 405,
	"./languages/git-svg.svg": 997,
	"./languages/github.svg": 26,
	"./languages/graphql.svg": 828,
	"./languages/html.svg": 581,
	"./languages/index": 440,
	"./languages/index.js": 440,
	"./languages/intellij.svg": 256,
	"./languages/java.svg": 875,
	"./languages/javascript.svg": 378,
	"./languages/next.svg": 376,
	"./languages/node.svg": 143,
	"./languages/psql.svg": 946,
	"./languages/react.svg": 24,
	"./languages/socket-io.svg": 418,
	"./languages/spring.svg": 2,
	"./languages/sql.svg": 586,
	"./languages/typescript.svg": 282,
	"./languages/vs.svg": 984,
	"./languages/webpack.svg": 87,
	"./linkedin-icon.svg": 504,
	"./mail-icon.svg": 515,
	"./profile.jpeg": 477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;